<script setup>
import { computed, ref, watch } from 'vue'
import { extActionButtonMenuProps } from '../src/props'
import ActionButton from '../../ActionButton/src/index.vue'

const props = defineProps(extActionButtonMenuProps())

const menu = ref(false)
const inputValue = ref('')
const selectionRange = ref(null)

const currentSpacing = computed(() => {
  const { letterSpacing } = props.editor.getAttributes('textStyle')
  return letterSpacing == null ? '' : String(letterSpacing).replace(/px$/, '')
})

watch(currentSpacing, (value) => {
  inputValue.value = value
}, { immediate: true })

watch(menu, (isOpen) => {
  if (!isOpen) return
  const selection = props.editor?.state?.selection
  if (!selection) return
  selectionRange.value = {
    from: selection.from,
    to: selection.to,
  }
})

const isActive = () => {
  const { letterSpacing } = props.editor.getAttributes('textStyle')
  return letterSpacing !== undefined && letterSpacing !== null && letterSpacing !== ''
}

function apply() {
  const raw = String(inputValue.value || '').trim()
  let chain = props.editor.chain().focus()
  if (selectionRange.value?.from != null && selectionRange.value?.to != null) {
    chain = chain.setTextSelection({
      from: selectionRange.value.from,
      to: selectionRange.value.to,
    })
  }
  if (!raw) {
    if (chain.unsetLetterSpacing) chain.unsetLetterSpacing().run()
    menu.value = false
    return
  }
  if (chain.setLetterSpacing) chain.setLetterSpacing(raw).run()
  menu.value = false
}

function reset() {
  let chain = props.editor.chain().focus()
  if (selectionRange.value?.from != null && selectionRange.value?.to != null) {
    chain = chain.setTextSelection({
      from: selectionRange.value.from,
      to: selectionRange.value.to,
    })
  }
  if (chain.unsetLetterSpacing) chain.unsetLetterSpacing().run()
  inputValue.value = ''
  menu.value = false
}
</script>

<template>
  <ActionButton
    :editor="editor"
    icon="letterSpacing"
    :tooltip="t('editor.letterSpacing.tooltip')"
    :disabled="!(
      editor?.schema?.marks?.textStyle &&
      editor?.can?.().setLetterSpacing ? editor.can().setLetterSpacing('0') : false
    )"
    :is-active="isActive"
  >
    <VMenu v-model="menu" activator="parent" :close-on-content-click="false">
      <VCard min-width="220" class="pa-3">
        <VTextField
          v-model="inputValue"
          type="number"
          density="compact"
          variant="outlined"
          :label="t('editor.letterSpacing.label')"
          suffix="px"
          hide-details
          @keydown.enter.prevent="apply"
        />
        <div class="d-flex justify-end ga-2 mt-3">
          <VBtn variant="text" size="small" @click="reset">
            {{ t('editor.letterSpacing.reset') }}
          </VBtn>
          <VBtn color="primary" size="small" @click="apply">
            {{ t('editor.letterSpacing.apply') }}
          </VBtn>
        </div>
      </VCard>
    </VMenu>
  </ActionButton>
</template>
